export default "__VITE_ASSET__7oiL4nFW__"